const formControlLabelModalPlace = {
  business: 'Branch',
  room: 'Leaf'
};

export default formControlLabelModalPlace;
